/**
 * Queries GraphQL AppSync.
 *
 * Copiate verbatim da:
 *   - enermed-app/aws-utils/queriesContratto.js
 *   - enermed-app/aws-utils/queriesDevices.js
 *
 * Mantenere allineamento 1:1 con il mobile: ogni modifica deve essere fatta
 * prima lato mobile (dove è già testato), poi qui.
 *
 * Convenzione: la prima lettera del nome operazione segue il backend
 * (es. `ListMessaggi` con L maiuscola, `getCliente` con g minuscola).
 */

// ============================================================
// CLIENTE / CONTRATTI
// ============================================================

export const GET_CLIENTE = /* GraphQL */ `
  query getCliente($codice_cliente: String!) {
    getCliente(codice_cliente: $codice_cliente) {
      anni_fornitura
      contratti {
        alerts {
          stato
          tipo
        }
        cliente {
          codice_cliente
          email
          nome_completo
          phone
          stripe_cus_id
        }
        codice_contratto
        credito_prepagata
        data_inizio
        data_stipula
        devices {
          loads {
            R
            S
            T
          }
          serial
          thing_name
          type
          data_rimozione
          data_installazione
        }
        has_quarti
        intervallo_fatturazione
        metodo_pagamento
        offerta {
          codice_offerta
          data_scadenza
          nome
          prezzi {
            F1
            F2
            F3
          }
          tariffa
          tipo
        }
        pod {
          etichetta
          indirizzo
          pod
        }
        potenza_disponibile
        potenza_impegnata
        soglia_spesa
        stato
        supporto_fatturazione
        uso
        co2_compensabile
        co2_compensata
        n_alberi
        consumo_annuo
      }
      monitoraggio {
        alerts {
          stato
          tipo
        }
        cliente {
          codice_cliente
          email
          nome_completo
          phone
          stripe_cus_id
        }
        codice_contratto
        credito_prepagata
        data_stipula
        data_inizio
        devices {
          loads {
            R
            S
            T
          }
          serial
          thing_name
          type
          data_rimozione
          data_installazione
        }
        has_quarti
        intervallo_fatturazione
        metodo_pagamento
        offerta {
          codice_offerta
          data_scadenza
          nome
          prezzi {
            F1
            F2
            F3
          }
          tariffa
          tipo
        }
        pod {
          etichetta
          indirizzo
          pod
        }
        potenza_disponibile
        potenza_impegnata
        soglia_spesa
        stato
        supporto_fatturazione
        uso
      }
    }
  }
`

// ============================================================
// BOLLETTE
// ============================================================

export const GET_BOLLETTE_CONTRATTO = /* GraphQL */ `
  query getBolletteContratto($codice_cliente: String!, $codice_contratto: String!) {
    getBolletteContratto(
      codice_cliente: $codice_cliente
      codice_contratto: $codice_contratto
    ) {
      A
      B
      C
      D
      E
      F
      G
      H
      al
      codice
      consumo
      corrispettivo_unitario
      dal
      data_emissione
      data_scadenza
      imponibile
      stato
      url_bollettino
      url_dettaglio
      url_semplice
    }
  }
`

export const GET_DETTAGLIO_BOLLETTA = /* GraphQL */ `
  query getDettaglioBolletta(
    $codice_cliente: String!
    $codice_contratto: String!
    $invoice: String!
  ) {
    getDettaglioBolletta(
      codice_cliente: $codice_cliente
      codice_contratto: $codice_contratto
      invoice: $invoice
    )
  }
`

// ============================================================
// CONSUMI
// ============================================================

export const GET_CONSUMO_ANNO = /* GraphQL */ `
  query getConsumoContrattoAnno(
    $codice_cliente: String!
    $codice_contratto: String!
  ) {
    getConsumoContrattoAnno(
      codice_cliente: $codice_cliente
      codice_contratto: $codice_contratto
    ) {
      F1
      F2
      F3
      name
      value
      reliable
    }
  }
`

export const GET_CONSUMO_BIMESTRE = /* GraphQL */ `
  query getConsumoContrattoBimestre(
    $codice_cliente: String!
    $codice_contratto: String!
  ) {
    getConsumoContrattoBimestre(
      codice_cliente: $codice_cliente
      codice_contratto: $codice_contratto
    ) {
      F1
      F2
      F3
      name
      value
      reliable
    }
  }
`

// ============================================================
// NEWS / MESSAGGI / LETTURE
// ============================================================

export const GET_NEWS = /* GraphQL */ `
  query getNews {
    getNews {
      datetime
      img
      title
      contenuto
      allegato
      incipit
    }
  }
`

export const LIST_MESSAGGI = /* GraphQL */ `
  query ListMessaggi($codice_cliente: String!) {
    ListMessaggi(codice_cliente: $codice_cliente) {
      codice_cliente
      datetime
      letto
      testo
    }
  }
`

export const GET_LETTURE = /* GraphQL */ `
  query getLetture($codice_contratto: String!) {
    getLetture(codice_contratto: $codice_contratto) {
      tipo
      tipo_sigla
      data
      f1
      f2
      f3
    }
  }
`

// ============================================================
// PROMOZIONI
// ============================================================

export const GET_PROMOZIONI = /* GraphQL */ `
  query getPromozioni {
    getPromozioni {
      image_url
      message
      name
    }
  }
`

// ============================================================
// DEVICES (potenza istantanea)
// Riservato a feature Consumi → istantaneo (subscription)
// ============================================================

export const CURR_POWER = /* GraphQL */ `
  query currPower($devices: [String]!, $codice_contratto: String!) {
    currPower(devices: $devices, codice_contratto: $codice_contratto) {
      attiva
      fotovoltaico
      time
      reliable
    }
  }
`

export const ON_PUBLISH_CURR_POWER = /* GraphQL */ `
  subscription onPublishCurrPower($codice_contratto: String!) {
    onPublishCurrPower(codice_contratto: $codice_contratto) {
      time
      attiva
      fotovoltaico
      consumo
      reliable
      codice_contratto
    }
  }
`

// Frammento riusabile per i 4 endpoint timed (currHour/Day/Month/prevMonth)
// che ritornano tutti `DeviceResponse { summary, details }`.
const DEVICE_RESPONSE_FIELDS = /* GraphQL */ `
  details {
    attiva { time value reliable F1 F2 F3 costo past }
    consumo { time value reliable F1 F2 F3 costo past }
    fotovoltaico { time value reliable F1 F2 F3 costo past }
  }
  summary {
    costo
    attiva { F1 F2 F3 value }
    consumo { F1 F2 F3 value }
    fotovoltaico { F1 F2 F3 value }
  }
`

export const CURR_HOUR = /* GraphQL */ `
  query currHour($from_date: AWSDateTime, $codice_contratto: String!) {
    currHour(from_date: $from_date, codice_contratto: $codice_contratto) {
      ${DEVICE_RESPONSE_FIELDS}
    }
  }
`

export const CURR_DAY = /* GraphQL */ `
  query currDay($codice_contratto: String!) {
    currDay(codice_contratto: $codice_contratto) {
      ${DEVICE_RESPONSE_FIELDS}
    }
  }
`

export const CURR_MONTH = /* GraphQL */ `
  query currMonth($codice_contratto: String!) {
    currMonth(codice_contratto: $codice_contratto) {
      ${DEVICE_RESPONSE_FIELDS}
    }
  }
`

export const PREV_MONTH = /* GraphQL */ `
  query prevMonth($from_date: AWSDateTime!, $codice_contratto: String!) {
    prevMonth(from_date: $from_date, codice_contratto: $codice_contratto) {
      ${DEVICE_RESPONSE_FIELDS}
    }
  }
`
